import React from 'react';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';


const TrustIndicators = () => {
  const statistics = [
    {
      id: 1,
      value: "Herausragend",
      label: "Mandantenzufriedenheit",
      description: "Überdurchschnittliche Bewertungen",
      icon: "Heart",
      color: "text-trust-builder"
    },
    {
      id: 2,
      value: "Umfassend",
      label: "Rechtskenntnisse",
      description: "Breites Fachwissen",
      icon: "BookOpen",
      color: "text-conversion-accent"
    },
    {
      id: 3,
      value: "Persönlich",
      label: "Betreuungsqualität",
      description: "Individueller Service",
      icon: "Users",
      color: "text-primary"
    },
    {
      id: 4,
      value: "24/7",
      label: "Verfügbarkeit",
      description: "365 Tage im Jahr",
      icon: "Phone",
      color: "text-accent"
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Statistics */}
        <div className="mb-20">
          <div className="text-center mb-12">
            <h2 className="text-3xl lg:text-4xl font-bold text-text-primary mb-4">
              Unsere Stärken
            </h2>
            <p className="text-lg text-text-secondary max-w-3xl mx-auto">
              Was uns auszeichnet – verlässliche Qualitätsmerkmale unserer Rechtsberatung.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {statistics?.map((stat, index) => (
              <motion.div
                key={stat?.id}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="text-center group"
              >
                <div className="bg-surface rounded-xl p-6 card-hover">
                  <div className="flex items-center justify-center w-16 h-16 bg-white rounded-full shadow-professional mx-auto mb-4 group-hover:scale-110 transition-transform duration-300">
                    <Icon name={stat?.icon} size={24} className={stat?.color} strokeWidth={2} />
                  </div>
                  <div className={`text-3xl font-bold ${stat?.color} mb-2`}>
                    {stat?.value}
                  </div>
                  <div className="text-lg font-semibold text-text-primary mb-1">
                    {stat?.label}
                  </div>
                  <div className="text-sm text-text-secondary">
                    {stat?.description}
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>

        {/* Trust Statement */}
        <div className="bg-gradient-to-r from-primary to-accent rounded-2xl p-8 text-white text-center">
          <div className="max-w-3xl mx-auto">
            <Icon name="Shield" size={48} color="white" className="mx-auto mb-4" />
            <h3 className="text-2xl font-bold mb-4">
              Ihr Vertrauen ist unser höchstes Gut
            </h3>
            <p className="text-white/90 text-lg leading-relaxed">
              Als ADVOCALL RECHTSANWALTSGESELLSCHAFT MBH stehen wir für höchste
              professionelle Standards, absolute Vertraulichkeit und kompromisslose
              Qualität in der Rechtsberatung. Ihre rechtlichen Angelegenheiten sind
              bei uns in den besten Händen.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustIndicators;